<h1>Cancel Enrollment</h1>

<section>
<p>If you cancel, you won't be able to do the thing.
<p><button (click)="cancelSubscription()">Are you Sure?</button>
</section>
